import { Box, BoxProps } from "@mui/material";
import { FC } from "react";
import { TIconNames } from "src/shared/types/iconNames";

export interface IIconProps extends BoxProps {
  iconname: TIconNames;
}

export const IconComponent: FC<IIconProps> = ({
  iconname,
  className,
  sx,
  ...svgProps
}) => {
  return (
    <Box
      viewBox="0 0 16 16"
      component="svg"
      className={`icons ${iconname}  ${className || ""}`}
      sx={{
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        height: "1em",
        width: "1em",
        verticalAlign: "middle",
        ...sx,
      }}
      {...svgProps}
    >
      <use xlinkHref={`#${iconname}`} />
    </Box>
  );
};

export default IconComponent;
